import MUIStep, { StepProps } from '@mui/material/Step';
import MUIStepIcon, { StepIconProps } from '@mui/material/StepIcon';
import MUIStepLabel, { StepLabelProps } from '@mui/material/StepLabel';
import MUIStepper, { StepperProps } from '@mui/material/Stepper';
import React from 'react';

export const MuiStep = (props: StepProps) => {
	return <MUIStep {...props} />;
};

export const MuiStepper = (props: StepperProps) => {
	return <MUIStepper {...props} />;
};

export const MuiStepLabel = (props: StepLabelProps) => {
	return <MUIStepLabel {...props} />;
};

export const MuiStepIcon = (props: StepIconProps) => {
	return <MUIStepIcon {...props} />;
};
